<template>
  <div class="flex w-full flex-col justify-end md:w-auto">
    <PaymentSubmitButton
      :action-type
      class="min-w-full md:min-w-160"
      :form
      full-width="never"
      :loading="form?.isFormBusy"
    >
      <template v-if="Boolean(providerName)" #default>
        {{
          i18n(translations.submitButton, {
            providerName,
          })
        }}
      </template>
    </PaymentSubmitButton>
    <SecurityReassuranceCaption />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { paymentGroupProviderName } from '../../../methods/helpers/methods'
import type { PaymentFormInstance } from '../../types/PaymentFormInstance'
import type { PaymentSubmitButtonActionType } from '../../types/PaymentSubmitButtonActionType'

import translations from './BrandedPaymentSubmitButton.translations'
import PaymentSubmitButton from './PaymentSubmitButton.vue'
import SecurityReassuranceCaption from './components/SecurityReassuranceCaption.vue'

const props = defineProps<{
  form: PaymentFormInstance | null
  actionType?: PaymentSubmitButtonActionType
}>()

const i18n = useI18n()

const providerName = computed(() => {
  const method = props.form?.methodFormInstance?.method
  if (method) {
    return paymentGroupProviderName(method.group, i18n)
  }

  return null
})
</script>
